import isEmpty from 'lodash.isempty'
import { isClient } from '@cred/shared/utils'
import { WIDGET_ERROR_PREFIX } from '../const'

const setCssVars = ({ partnersCSSVars }, logger) => {
  if (!partnersCSSVars || isEmpty(partnersCSSVars) || !isClient()) {
    return
  }
  try {
    Object.entries(partnersCSSVars).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value)
    })
  } catch (e) {
    // eslint-disable-next-line no-console
    if (logger) {
      logger.error(`${WIDGET_ERROR_PREFIX} Error while setting Custom Styles`, e)
    }
    console.warn(`${WIDGET_ERROR_PREFIX} Error while setting Custom Styles`)
  }
}

export default setCssVars
